import * as signalR from "@microsoft/signalr";


let connection = null;

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

//const { signalRLogout } = useAuth();

export const startSignalR = async (token, onMessage) => {

    // Prevent duplicate connections
    if (connection) {
      //  console.log("SignalR already exists");
        return connection;
    }

    connection = new signalR.HubConnectionBuilder()        
        .withUrl(`${API_BASE_URL}/PNotificationHub`, {
            accessTokenFactory: () => token,
        })
        .withAutomaticReconnect()
        //.configureLogging(signalR.LogLevel.Trace) //To print logs in console
        .configureLogging(signalR.LogLevel.None)
        .build();

    //// Receive notifications
    //connection.on("ReceiveNotificationEOP", (data) => {
    //   // console.log("Notification received:", data);

    //    if (onMessage) {
    //        onMessage(data);
    //    }
    //});


    //connection.on("UserLogout", (data) => {
    //    console.log("Logout Notification received:", data);

    //    if (onMessage) {
    //        onMessage(data);
    //    }
    //});
    // Receive notifications EOP
    connection.on("ReceiveNotificationEOP", (data) => {
        onMessage?.({
            type: "ReceiveNotificationEOP",
            data
        });
    });

    // Receive notifications UserLogout
    connection.on("UserLogout", (data) => {

        onMessage?.({
            type: "UserLogout",
            data
        });
    });


    // Receive notifications UserLogout
    connection.on("UserPermissionUpdate", (data) => {
        //console.log("UserPermissionUpdate Notification received:", data);
        onMessage?.({
            type: "UserPermissionUpdate",
            data
        });
    });


    // Receive notifications when new Provider Admin register
    connection.on("RegisterNewProviderAdmin", (data) => {
       // console.log("RegisterNewProviderAdmin Notification received:", data);
        onMessage?.({
            type: "RegisterNewProviderAdmin",
            data
        });
    });


    //AppSettingsUpdate
    connection.on("AppSettingsUpdate", (data) => {
       // console.log("AppSettingsUpdate Notification received:", data);
        onMessage?.({
            type: "AppSettingsUpdate",
            data
        });
    });



    // Lifecycle events
    connection.onclose((err) => {
       // console.log("SignalR Closed:", err);
    });

    connection.onreconnecting((err) => {
      //  console.log("SignalR Reconnecting:", err);
    });

    connection.onreconnected((id) => {
       // console.log("SignalR Reconnected:", id);
    });

    try {
        // IMPORTANT: await connection start
        await connection.start();

      //  console.log("SignalR Connected");

        return connection;

    } catch (err) {
        console.error(" SignalR Connection Error:", err);

        connection = null;

        throw err;
    }
};

export const stopSignalR = async () => {

    if (connection) {

        try {
            await connection.stop();

           // console.log("SignalR Disconnected");

        } catch (err) {

            console.error("SignalR Stop Error:", err);

        } finally {

            connection = null;
        }
    }
};